import { render } from "./DefaultSidebar.vue?vue&type=template&id=0cc527fd"
import script from "./DefaultSidebar.vue?vue&type=script&lang=js"
export * from "./DefaultSidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__